exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch-wrapper.doubleOut .text-straight-out {\n  opacity: 0.5; }\n\n.switch-wrapper.doubleOut .bullet {\n  bottom: 0; }\n\n.switch-wrapper.straightOut .text-double-out {\n  opacity: 0.5; }\n\n.switch-wrapper.straightOut .bullet {\n  top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/switch/switch.component.scss
// module id = ./src/app/components/switch/switch.component.scss
// module chunks = main